/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Paste_HelpInputs */

const en_editor_paste_help = /** @type {(inputs: Editor_Paste_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each line becomes an entry. A line ending in a colon ("Sauce:") starts a group.`)
};

const de_editor_paste_help = /** @type {(inputs: Editor_Paste_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Zeile wird ein Eintrag. Eine Zeile mit Doppelpunkt („Sauce:“) beginnt eine Gruppe.`)
};

/**
* | output |
* | --- |
* | "Each line becomes an entry. A line ending in a colon (\"Sauce:\") starts a group." |
*
* @param {Editor_Paste_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_paste_help = /** @type {((inputs?: Editor_Paste_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Paste_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_paste_help(inputs)
	return en_editor_paste_help(inputs)
});